import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DraggableCore } from 'react-draggable';

class DraggableWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasDragged: false,
    };
  }

  handleDrag = (e, ui) => {
    this.setState({ hasDragged: true }, () => {
      this.props.onDrag(e, ui, false);
    });
  };

  handleDragStart = (e, ui) => {
    this.props.onDragStart(e, ui);
  };

  handleStop = (e, ui) => {
    const { hasDragged } = this.state;

    if (hasDragged) {
      this.setState({ hasDragged: false }, () => {
        this.props.onDrag(e, ui, true);
      });
    }
  };

  render() {
    const { draggable } = this.props;

    return draggable
    ? (
      <DraggableCore
        onDrag={this.handleDrag}
        onStart={this.handleDragStart}
        onStop={this.handleStop}
        onMouseDown={this.props.onMouseDown}
        grid={this.props.grid}
        axis={this.props.axis}
      >
        { this.props.children }
      </DraggableCore>
    )
    : this.props.children;
  }
}

DraggableWrapper.propTypes = {
  onDrag: PropTypes.func,
  onDragStart: PropTypes.func,
  onMouseDown: PropTypes.func,
  children: PropTypes.node.isRequired,
  grid: PropTypes.arrayOf(PropTypes.number),
  draggable: PropTypes.bool,
  axis: PropTypes.string,
};

DraggableWrapper.defaultProps = {
  onDrag: () => {},
  onDragStart: () => {},
  onMouseDown: () => {},
  grid: null,
  draggable: true,
  axis: 'xy',
};

export default DraggableWrapper;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/DraggableWrapper/DraggableWrapper.jsx